import {
  Box,
  Stack,
  Typography,
  Grid2 as Grid,
  Link,
  IconButton,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import {STYLE} from "./STYLES";

interface FooterDataProps {
  title: string;
  links: {
    title: string;
    href: string;
  }[];
}

const footerData: FooterDataProps[] = [
  {
    title: "Product",
    links: [
      {title: "Pricing", href: "#"},
      {title: "Features", href: "#"},
      {title: "Testimonials", href: "#"},
    ],
  },
  {
    title: "Exams",
    links: [
      {title: "CAT", href: "#"},
      {title: "JEE Main", href: "#"},
    ],
  },
  {
    title: "Company",
    links: [
      {title: "Developers", href: "#"},
      {title: "Careers", href: "#"},
    ],
  },
  {
    title: "Legal",
    links: [
      {title: "Terms", href: "#"},
      {title: "Security", href: "#"},
      {title: "Privacy", href: "#"},
    ],
  },
];

const footerSocialLinks = [
  {
    icon: InstagramIcon,
    href: "#",
  },
  {
    icon: LinkedInIcon,
    href: "#",
  },
  {
    icon: FacebookIcon,
    href: "#",
  },
];

export default function FooterSection() {
  return (
    <Box component="footer" sx={{py: 2.5, mx: "auto", width: "80%"}}>
      <Stack direction={"row"} width={"100%"} height={"100%"}>
        <Stack height={"100%"} justifyContent={"space-between"}>
          <Stack spacing={2}>
            <Link href="mailto:hi@prepgenie.com" sx={STYLE.footerMailLink}>
              <EmailIcon sx={{mr: 1}} />
              <Typography variant="body1">hi@prepgenie.com</Typography>
            </Link>
            <Stack direction="row" spacing={1}>
              {footerSocialLinks.map(link => (
                <IconButton
                  key={link.href}
                  color="inherit"
                  aria-label={link.icon.name}
                  component="a"
                  href={link.href}
                  target="_blank"
                  sx={STYLE.footerSocialLink}>
                  <link.icon />
                </IconButton>
              ))}
            </Stack>
          </Stack>
          <Box height={32} />
          {/* Copyright */}
          <Typography sx={STYLE.footerCopyright}>
            © 2025 Made by Mindcore AI Solutions
          </Typography>
        </Stack>
        <Box flexGrow={1} />
        {/* Product Links */}
        <Grid container spacing={16}>
          {footerData.map(item => (
            <Grid size={3} key={item.title}>
              <Typography sx={STYLE.footerTitle} gutterBottom>
                {item.title}
              </Typography>
              <Stack spacing={"1rem"}>
                {item.links.map(link => (
                  <Link
                    key={link.title}
                    href={link.href}
                    underline="hover"
                    sx={STYLE.footerLink}>
                    {link.title}
                  </Link>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Box>
  );
}
